import { lazy } from "react";
import { RouteObject } from "react-router-dom";
import Constria from "@/pages/admin/miscellaneous/constria/travel-leaders-network";

const Error404 = lazy(() => import("@/pages/Error404"));

const miscRoutes: RouteObject[] = [
  {
    index: true,
    element: <Error404 />,
  },
  {
    path: "constria",
    element: <Constria />,
  },
];

export default miscRoutes;
